import api from "@/services/api";
import { PaginatedResponse } from "@/types";
import {
  ScrapedCategory,
  ScrapedCategoryBrand,
  ScrapedCategoryFilters,
  UpdateScrapedCategory,
  UpdateScrapedCategoryBrand,
} from "@/types/scrape-category";

export class ScrapedCategoryRepository {
  async findAll(
    filters: ScrapedCategoryFilters,
  ): Promise<PaginatedResponse<ScrapedCategory>> {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        params.append(key, value.toString());
      }
    });

    const response = await api.get(
      `/v1/admin/scrape-categories?${params.toString()}`,
    );

    return response.data as PaginatedResponse<ScrapedCategory>;
  }

  async findById(id: string): Promise<ScrapedCategory> {
    const response = await api.get<ScrapedCategory>(
      `/v1/admin/scrape-categories/${id}`,
    );

    return response.data;
  }

  async update(data: UpdateScrapedCategory): Promise<ScrapedCategory> {
    const response = await api.patch<ScrapedCategory>(
      `/v1/admin/scrape-categories/${data.id}`,
      {
        blacklist: data.blacklist,
        linkedCategoryId: data.linkedCategoryId,
      },
    );

    return response.data;
  }

  async updateBrand(
    data: UpdateScrapedCategoryBrand,
  ): Promise<ScrapedCategoryBrand> {
    const response = await api.patch<ScrapedCategoryBrand>(
      `/v1/admin/scrape-categories/${data.categoryId}/brands/${data.brandId}`,
      {
        blacklist: data.blacklist,
        linkedBrandId: data.linkedBrandId,
      },
    );

    return response.data;
  }
}
